'use client';

import { c as _c } from "react/compiler-runtime";
import { ErrorBoundary, Provider } from '@rollbar/react';
import { QueryClientProvider } from '@systemeio/file-manager';
import { Toast } from '@systemeio/ui';
import { fixFailedToExecuteRemoveChildOnNode } from '@systemeio/util';
import { GrowthbookClientProvider } from 'growthbook/client';
import { rollbar } from 'rollbar/instance';
import { META_DATA_FROM_SERVER_KEY, MetaDataFromServerInterface } from 'shared/hooks/use-metadata-from-server';
import { useRouter } from 'shared/hooks/use-router';
import { SWRConfig } from 'swr';
import type { PropsWithChildren } from 'react';
import { LocaleProviders } from './locale-providers';
fixFailedToExecuteRemoveChildOnNode();
interface RootProvidersProps extends PropsWithChildren, MetaDataFromServerInterface {}
export function RootProviders(t0) {
  const $ = _c(12);
  const {
    children,
    hostOnServer,
    serverDeviceType
  } = t0;
  const router = useRouter();
  let t1;
  if ($[0] !== hostOnServer || $[1] !== serverDeviceType) {
    t1 = {
      revalidateOnFocus: false,
      revalidateIfStale: false,
      onErrorRetry: _temp,
      fallback: {
        [META_DATA_FROM_SERVER_KEY]: {
          hostOnServer,
          serverDeviceType
        }
      }
    };
    $[0] = hostOnServer;
    $[1] = serverDeviceType;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Toast />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== children) {
    t3 = <QueryClientProvider>{children}{t2}</QueryClientProvider>;
    $[4] = children;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== router.asPath || $[7] !== t3) {
    t4 = <LocaleProviders><GrowthbookClientProvider currentPath={router.asPath}>{t3}</GrowthbookClientProvider></LocaleProviders>;
    $[6] = router.asPath;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t1 || $[10] !== t4) {
    t5 = <Provider instance={rollbar}><ErrorBoundary><SWRConfig value={t1}>{t4}</SWRConfig></ErrorBoundary></Provider>;
    $[9] = t1;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}
function _temp(error, key, config, revalidate, t0) {
  const {
    retryCount
  } = t0;
  if (retryCount > 3) {
    if (error.status === 502 || error.status === 504) {
      return;
    }
  }
}